import React from 'react';
import { registerWidget } from '@okapi/core';
import { getGlobalRouter } from '@okapi/router-react';
import { State } from 'store/types';
import { EngineeringSystemsTypes } from 'landings/engineering-systems';
import { FETCH_SERVICE_PRICE_LIST } from 'modules/services';
import { EngineeringSystemsRemote } from '../../common/widgets';
import { initWidgetDataWithShops } from '../init-widget-data-with-shops';

registerWidget<State, { system: EngineeringSystemsTypes }>(`${__NAME__}/engineering-systems`, state => {
  const router = getGlobalRouter();
  const store = initWidgetDataWithShops(state);

  store.dispatch(FETCH_SERVICE_PRICE_LIST.success, state.services?.servicePrice ?? undefined);

  return remoteProps => <EngineeringSystemsRemote router={router} store={store} {...remoteProps} />;
});
